import { default as app_45storen08HWfCeYkMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/app-store.vue?macro=true";
import { default as attendanceN7M2jNW9ZFMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/attendance.vue?macro=true";
import { default as end_45event_45listHp6aWgL7xJMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/end-event-list.vue?macro=true";
import { default as event_45listRkMpf4x04nMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event-list.vue?macro=true";
import { default as event_45testZNggkPG32eMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event-test.vue?macro=true";
import { default as _91eventId_93LITD4rqOP5Meta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/[eventId].vue?macro=true";
import { default as BLUE_45ARCHIVEDWDK9H7Tc4Meta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/BLUE-ARCHIVE.vue?macro=true";
import { default as GUARDIAN_TALES54Z5dRCvEWMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/GUARDIAN_TALES.vue?macro=true";
import { default as GUARDIAN_45TALESvkhg1QujiAMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/GUARDIAN-TALES.vue?macro=true";
import { default as PLKEY_45144BrEASnvx4Meta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PLKEY-14.vue?macro=true";
import { default as PLKEY_4515CwfCdgjT7AMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PLKEY-15.vue?macro=true";
import { default as PLKEY_4517rLiZiIGfkJMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PLKEY-17.vue?macro=true";
import { default as PRICONNE_45THEMEbqPSluxOWYMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PRICONNE-THEME.vue?macro=true";
import { default as WHATS_NEW_45GT4_45ENikrLIbTR4vMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4-EN.vue?macro=true";
import { default as WHATS_NEW_45GT4Kqun2JFNhQMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4.vue?macro=true";
import { default as WHATS_NEW_45PRICONNEaPSYzkQh7ZMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/WHATS_NEW-PRICONNE.vue?macro=true";
import { default as homejoAv1F52m2Meta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/home.vue?macro=true";
import { default as storeG7uFEGlv5MMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/store.vue?macro=true";
import { default as tests8aEAHHqrYMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/test.vue?macro=true";
import { default as theme_45selectorHx6FWjGIGoMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/theme-selector.vue?macro=true";
import { default as your_45emotionsY9LWVX8xOmMeta } from "/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/your-emotions.vue?macro=true";
export default [
  {
    name: app_45storen08HWfCeYkMeta?.name ?? "app-store",
    path: app_45storen08HWfCeYkMeta?.path ?? "/app-store",
    meta: app_45storen08HWfCeYkMeta || {},
    alias: app_45storen08HWfCeYkMeta?.alias || [],
    redirect: app_45storen08HWfCeYkMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/app-store.vue").then(m => m.default || m)
  },
  {
    name: attendanceN7M2jNW9ZFMeta?.name ?? "attendance",
    path: attendanceN7M2jNW9ZFMeta?.path ?? "/attendance",
    meta: attendanceN7M2jNW9ZFMeta || {},
    alias: attendanceN7M2jNW9ZFMeta?.alias || [],
    redirect: attendanceN7M2jNW9ZFMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/attendance.vue").then(m => m.default || m)
  },
  {
    name: end_45event_45listHp6aWgL7xJMeta?.name ?? "end-event-list",
    path: end_45event_45listHp6aWgL7xJMeta?.path ?? "/end-event-list",
    meta: end_45event_45listHp6aWgL7xJMeta || {},
    alias: end_45event_45listHp6aWgL7xJMeta?.alias || [],
    redirect: end_45event_45listHp6aWgL7xJMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/end-event-list.vue").then(m => m.default || m)
  },
  {
    name: event_45listRkMpf4x04nMeta?.name ?? "event-list",
    path: event_45listRkMpf4x04nMeta?.path ?? "/event-list",
    meta: event_45listRkMpf4x04nMeta || {},
    alias: event_45listRkMpf4x04nMeta?.alias || [],
    redirect: event_45listRkMpf4x04nMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event-list.vue").then(m => m.default || m)
  },
  {
    name: event_45testZNggkPG32eMeta?.name ?? "event-test",
    path: event_45testZNggkPG32eMeta?.path ?? "/event-test",
    meta: event_45testZNggkPG32eMeta || {},
    alias: event_45testZNggkPG32eMeta?.alias || [],
    redirect: event_45testZNggkPG32eMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event-test.vue").then(m => m.default || m)
  },
  {
    name: _91eventId_93LITD4rqOP5Meta?.name ?? "event-eventId",
    path: _91eventId_93LITD4rqOP5Meta?.path ?? "/event/:eventId()",
    meta: _91eventId_93LITD4rqOP5Meta || {},
    alias: _91eventId_93LITD4rqOP5Meta?.alias || [],
    redirect: _91eventId_93LITD4rqOP5Meta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/[eventId].vue").then(m => m.default || m)
  },
  {
    name: BLUE_45ARCHIVEDWDK9H7Tc4Meta?.name ?? "event-BLUE-ARCHIVE",
    path: BLUE_45ARCHIVEDWDK9H7Tc4Meta?.path ?? "/event/BLUE-ARCHIVE",
    meta: BLUE_45ARCHIVEDWDK9H7Tc4Meta || {},
    alias: BLUE_45ARCHIVEDWDK9H7Tc4Meta?.alias || [],
    redirect: BLUE_45ARCHIVEDWDK9H7Tc4Meta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/BLUE-ARCHIVE.vue").then(m => m.default || m)
  },
  {
    name: GUARDIAN_TALES54Z5dRCvEWMeta?.name ?? "event-GUARDIAN_TALES",
    path: GUARDIAN_TALES54Z5dRCvEWMeta?.path ?? "/event/GUARDIAN_TALES",
    meta: GUARDIAN_TALES54Z5dRCvEWMeta || {},
    alias: GUARDIAN_TALES54Z5dRCvEWMeta?.alias || [],
    redirect: GUARDIAN_TALES54Z5dRCvEWMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/GUARDIAN_TALES.vue").then(m => m.default || m)
  },
  {
    name: GUARDIAN_45TALESvkhg1QujiAMeta?.name ?? "event-GUARDIAN-TALES",
    path: GUARDIAN_45TALESvkhg1QujiAMeta?.path ?? "/event/GUARDIAN-TALES",
    meta: GUARDIAN_45TALESvkhg1QujiAMeta || {},
    alias: GUARDIAN_45TALESvkhg1QujiAMeta?.alias || [],
    redirect: GUARDIAN_45TALESvkhg1QujiAMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/GUARDIAN-TALES.vue").then(m => m.default || m)
  },
  {
    name: PLKEY_45144BrEASnvx4Meta?.name ?? "event-PLKEY-14",
    path: PLKEY_45144BrEASnvx4Meta?.path ?? "/event/PLKEY-14",
    meta: PLKEY_45144BrEASnvx4Meta || {},
    alias: PLKEY_45144BrEASnvx4Meta?.alias || [],
    redirect: PLKEY_45144BrEASnvx4Meta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PLKEY-14.vue").then(m => m.default || m)
  },
  {
    name: PLKEY_4515CwfCdgjT7AMeta?.name ?? "event-PLKEY-15",
    path: PLKEY_4515CwfCdgjT7AMeta?.path ?? "/event/PLKEY-15",
    meta: PLKEY_4515CwfCdgjT7AMeta || {},
    alias: PLKEY_4515CwfCdgjT7AMeta?.alias || [],
    redirect: PLKEY_4515CwfCdgjT7AMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PLKEY-15.vue").then(m => m.default || m)
  },
  {
    name: PLKEY_4517rLiZiIGfkJMeta?.name ?? "event-PLKEY-17",
    path: PLKEY_4517rLiZiIGfkJMeta?.path ?? "/event/PLKEY-17",
    meta: PLKEY_4517rLiZiIGfkJMeta || {},
    alias: PLKEY_4517rLiZiIGfkJMeta?.alias || [],
    redirect: PLKEY_4517rLiZiIGfkJMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PLKEY-17.vue").then(m => m.default || m)
  },
  {
    name: PRICONNE_45THEMEbqPSluxOWYMeta?.name ?? "event-PRICONNE-THEME",
    path: PRICONNE_45THEMEbqPSluxOWYMeta?.path ?? "/event/PRICONNE-THEME",
    meta: PRICONNE_45THEMEbqPSluxOWYMeta || {},
    alias: PRICONNE_45THEMEbqPSluxOWYMeta?.alias || [],
    redirect: PRICONNE_45THEMEbqPSluxOWYMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/PRICONNE-THEME.vue").then(m => m.default || m)
  },
  {
    name: WHATS_NEW_45GT4_45ENikrLIbTR4vMeta?.name ?? "event-WHATS_NEW-GT4-EN",
    path: WHATS_NEW_45GT4_45ENikrLIbTR4vMeta?.path ?? "/event/WHATS_NEW-GT4-EN",
    meta: WHATS_NEW_45GT4_45ENikrLIbTR4vMeta || {},
    alias: WHATS_NEW_45GT4_45ENikrLIbTR4vMeta?.alias || [],
    redirect: WHATS_NEW_45GT4_45ENikrLIbTR4vMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4-EN.vue").then(m => m.default || m)
  },
  {
    name: WHATS_NEW_45GT4Kqun2JFNhQMeta?.name ?? "event-WHATS_NEW-GT4",
    path: WHATS_NEW_45GT4Kqun2JFNhQMeta?.path ?? "/event/WHATS_NEW-GT4",
    meta: WHATS_NEW_45GT4Kqun2JFNhQMeta || {},
    alias: WHATS_NEW_45GT4Kqun2JFNhQMeta?.alias || [],
    redirect: WHATS_NEW_45GT4Kqun2JFNhQMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/WHATS_NEW-GT4.vue").then(m => m.default || m)
  },
  {
    name: WHATS_NEW_45PRICONNEaPSYzkQh7ZMeta?.name ?? "event-WHATS_NEW-PRICONNE",
    path: WHATS_NEW_45PRICONNEaPSYzkQh7ZMeta?.path ?? "/event/WHATS_NEW-PRICONNE",
    meta: WHATS_NEW_45PRICONNEaPSYzkQh7ZMeta || {},
    alias: WHATS_NEW_45PRICONNEaPSYzkQh7ZMeta?.alias || [],
    redirect: WHATS_NEW_45PRICONNEaPSYzkQh7ZMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/event/WHATS_NEW-PRICONNE.vue").then(m => m.default || m)
  },
  {
    name: homejoAv1F52m2Meta?.name ?? "home",
    path: homejoAv1F52m2Meta?.path ?? "/home",
    meta: homejoAv1F52m2Meta || {},
    alias: homejoAv1F52m2Meta?.alias || [],
    redirect: homejoAv1F52m2Meta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/home.vue").then(m => m.default || m)
  },
  {
    name: storeG7uFEGlv5MMeta?.name ?? "store",
    path: storeG7uFEGlv5MMeta?.path ?? "/store",
    meta: storeG7uFEGlv5MMeta || {},
    alias: storeG7uFEGlv5MMeta?.alias || [],
    redirect: storeG7uFEGlv5MMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/store.vue").then(m => m.default || m)
  },
  {
    name: tests8aEAHHqrYMeta?.name ?? "test",
    path: tests8aEAHHqrYMeta?.path ?? "/test",
    meta: tests8aEAHHqrYMeta || {},
    alias: tests8aEAHHqrYMeta?.alias || [],
    redirect: tests8aEAHHqrYMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/test.vue").then(m => m.default || m)
  },
  {
    name: theme_45selectorHx6FWjGIGoMeta?.name ?? "theme-selector",
    path: theme_45selectorHx6FWjGIGoMeta?.path ?? "/theme-selector",
    meta: theme_45selectorHx6FWjGIGoMeta || {},
    alias: theme_45selectorHx6FWjGIGoMeta?.alias || [],
    redirect: theme_45selectorHx6FWjGIGoMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/theme-selector.vue").then(m => m.default || m)
  },
  {
    name: your_45emotionsY9LWVX8xOmMeta?.name ?? "your-emotions",
    path: your_45emotionsY9LWVX8xOmMeta?.path ?? "/your-emotions",
    meta: your_45emotionsY9LWVX8xOmMeta || {},
    alias: your_45emotionsY9LWVX8xOmMeta?.alias || [],
    redirect: your_45emotionsY9LWVX8xOmMeta?.redirect,
    component: () => import("/Users/jongminlee/git/bitbyte/PlayKeyboard_Webview/pages/your-emotions.vue").then(m => m.default || m)
  }
]